module.exports = __webpack_public_path__ + "stylesheets/section-horizontal-image-text_582b420c6b79e1d5ede15d3fe404d5b0.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-horizontal-image-text.less
// module id = JAU9
// module chunks = 154